import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@wix/design-system';
import s from './Enterprise.scss';
import { EnterpriseFeaturesItem } from './EnterpriseFeaturesItem';

export const EnterpriseFeatures: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={s.enterpriseFeaturesStrip}>
      <div className={s.enterpriseFeaturesContainer}>
        <Heading className={s.enterpriseFeaturesTitle} appearance='H2'>
          {t('enterprise_plans.features.title')}
        </Heading>
        <div className={s.enterpriseFeatures}>
          {EnterpriseFeaturesItemsData.map(EnterpriseFeaturesItem)}
        </div>
      </div>
    </div>
  );
};
export interface EnterpriseFeaturesItemData {
  icon: string;
  title: string;
  body: string;
  link?: string;
}

const EnterpriseFeaturesItemsData: EnterpriseFeaturesItemData[] = [
  {
    icon: 'personalized-plans',
    title: 'enterprise_plans.features.personalized_plans.title',
    body: 'enterprise_plans.features.personalized_plans.body',
  },
  {
    icon: 'support',
    title: 'enterprise_plans.features.support.title',
    body: 'enterprise_plans.features.support.body',
  },
  {
    icon: 'design-system',
    title: 'enterprise_plans.features.design_system.title',
    body: 'enterprise_plans.features.design_system.body',
  },
  {
    icon: 'coding',
    title: 'enterprise_plans.features.coding_integrations.title',
    body: 'enterprise_plans.features.coding_integrations.body',
  },
  {
    icon: 'security',
    title: 'enterprise_plans.features.security.title',
    body: 'enterprise_plans.features.security.body',
    link: 'enterprise_plans.features.security.body.link',
  },
  {
    icon: 'storage',
    title: 'enterprise_plans.features.storage.title',
    body: 'enterprise_plans.features.storage.body',
  },
  {
    icon: 'pro-service',
    title: 'enterprise_plans.features.professional_services.title',
    body: 'enterprise_plans.features.professional_services.body',
  },
  {
    icon: 'maintenance',
    title: 'enterprise_plans.features.maintenance_infrastructure.title',
    body: 'enterprise_plans.features.maintenance_infrastructure.body',
  },
  {
    icon: 'billing-solutions',
    title: 'enterprise_plans.features.billing.title',
    body: 'enterprise_plans.features.billing.body',
  },
];
